<div *appIfIsMobile class="top-input-modal safe-area-top">
  <div class="bg-white w-100 h-100">
    <div class="row mx-2 my-2 input-style">
      <div class="col-12 px-0">
        <app-search-restaurant-input
          inputClass="top-input-modal-input search-filters-mobile-location-input"
          (selectRestaurant)="onSelectRestaurant($event)"
        ></app-search-restaurant-input>

        <div class="search-city-find-me pl-2-25rem-pr-1-75rem safe-area-top">
          <a appHrefNone class="text-white" (click)="nearestClick()">Nearest</a>
        </div>
      </div>
    </div>

    <div class="row mx-2 my-2 input-style">
      <div class="col-12 px-0">
        <app-search-city-input
          [clearIcon]="clearIcon"
          (focus)="focusValue($event)"
          (input)="searchInputValue($event)"
          (selectPlace)="onSelectPlace($event)"
          (onFindMeClick)="onFindMe()"
          inputClass="top-input-modal-input search-filters-mobile-location-input"
        ></app-search-city-input>
      </div>
    </div>

    <div class="row mx-0 bg-white d-flex align-items-center">
      <app-search-filters
        *ngIf="country"
        [position]="searchFiltersPositionMobile"
        [country]="country"
        (stateSelectedChange)="onStateChange($event)"
        (localitySelectedChange)="onLocalitySelectedChange($event)"
        (countySelectedChange)="onCountyChange($event)"
        class="w-100"
      ></app-search-filters>
    </div>

    <div
      *ngIf="locationEnable"
      class="row mx-0 py-4 bg-blue d-flex align-items-center justify-content-center flex-column"
    >
      <div class="pb-3 text-white font-weight-400 font-size-1rem"> Enable browser location </div>

      <div [innerHTML]="htmlInstruction" class="text-white font-weight-400 font-size-1rem"></div>
    </div>

    <div
      *ngIf="!isLocalitySelected && stateSelected && !countySelected && stateSelected.flagUrl"
      class="row mx-0 bg-white d-flex align-items-center h-30vh"
    >
      <div class="d-flex flex-column align-items-center justify-content-center">
        <img
          class="w-100 h-100"
          [src]="stateSelected?.flagUrl"
          [alt]="stateSelected?.display"
        >
      </div>
    </div>
  </div>
</div>
